import type { WorkOrder } from '../../types/workOrder';

/**
 * Whether an unsynced Artisan profile may be synced to this work order.
 *
 * A work order that already carries a roast profile is not offered, because syncing would
 * replace it. Terminal work orders are excluded too: cancelling one releases its profile,
 * so without the status guard it would immediately reappear here as a valid target.
 *
 * `useRoastProfile` is the whole reason a work order can go missing from this list after it
 * was unlinked — the server clears the flag on unlink, so anything that writes it back
 * takes the work order out of circulation (AS-006).
 */
export const isEligibleArtisanSyncTarget = (
  wo: Pick<WorkOrder, 'useRoastProfile' | 'status'>,
): boolean => !wo.useRoastProfile && wo.status !== 'completed' && wo.status !== 'cancelled';
